export const addCategory = [
    'COMMUNICATION',
    'MARKETING',
    'PROMOTION',
    // ``FORMS`` is the user-visible category that the Send Forms wizard
    // filters on — admins tag a template with this value to make it
    // pickable in the wizard's email template dropdown. No new UI; lives
    // alongside the other categories in the same Engagement Messages
    // create flow.
    'FORMS',
    // ``ACKNOWLEDGEMENT`` is the post-submission patient ack bucket
    // (Send Forms PR-1). Distinct from FORMS so practices can author a
    // dedicated thank-you / signed-copy template surface that the new
    // FORM_SUBMISSION_ACK dispatcher picks up.
    'ACKNOWLEDGEMENT',
    'OTHER'
];

// Full set of engagement-template categories. Mirrors backend
// ``apps.commons.choices.TEMPLATE_USAGE_TYPE_CHOICES`` exactly — keep in
// sync if new values are added there. Used by the Engagement Messages
// tab for both the per-row category dropdown and the toolbar Category
// filter so every backend-supported value (including FORMS) is selectable.
export const ENGAGEMENT_TEMPLATE_CATEGORIES = [
    'MANUAL',
    'AUTOMATION',
    'NOTIFICATION',
    'TRANSACTIONAL',
    'REMINDER',
    'FOLLOW_UP',
    'COMMUNICATION',
    'MARKETING',
    'PROMOTION',
    'NEWSLETTER',
    'FORMS',
    'ACKNOWLEDGEMENT',
    'OTHER',
];

export const BeforeComa = '<';
export const AfterComa = '>';